import { Box, FieldWrapper } from '@dixa/lib-shared-habla';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { getFieldMeta } from '../../utils';
import { ToggleBox, ToggleBoxProps } from '../ui/toggleBox';

type FieldTogglePanelProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  dark?: boolean;
  noAlert?: boolean;
  /** Padding token or token-path */
  padding?: string | undefined;
  disabled?: boolean;
} & Pick<ToggleBoxProps, 'heading' | 'subHeading'>;

/** React Hook Form toggle panel component wrapped within a Habla FieldWrapper */
export function FieldTogglePanel<T extends FieldValues>({
  control,
  name,
  heading,
  subHeading,
  dark = false,
  noAlert,
  padding,
  disabled = false,
}: FieldTogglePanelProps<T>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const meta = getFieldMeta(fieldState);
        const { ref, ...fieldWithoutRef } = field;
        return (
          <FieldWrapper noLabel meta={meta} noAlert={noAlert}>
            <Box
              background={dark ? 'neutral.100' : undefined}
              borderRadius="100"
            >
              <ToggleBox
                {...fieldWithoutRef}
                onChange={field.onChange as (value: boolean) => void}
                heading={heading}
                subHeading={subHeading}
                dark={dark}
                padding={padding}
                disabled={disabled}
              />
            </Box>
          </FieldWrapper>
        );
      }}
    />
  );
}
